import { ReadMoreExpandable } from "@wags/ui/read-more-expandable.tsx";
import {
    PROVIDER_MISSION_ANCHOR,
    renderProviderAboutLink,
} from "./provider-about-link";

export function MissionSection({
    providerId,
    missionStatement,
}: {
    providerId: string;
    missionStatement: string;
}) {
    return (
        <section className="lg:grid lg:grid-cols-[280px_minmax(0,1fr)] lg:items-start lg:gap-x-16">
            <h2 className="text-section-title text-doberman-black text-balance">
                Our mission
            </h2>

            <ReadMoreExpandable
                lines={8}
                viewportFraction={0.58}
                renderPhoneLink={renderProviderAboutLink(
                    providerId,
                    PROVIDER_MISSION_ANCHOR,
                )}
                contentClassName="mt-4 max-w-prose whitespace-pre-line break-words lg:mt-0"
            >
                {missionStatement}
            </ReadMoreExpandable>
        </section>
    );
}
